<template>
    <default-layout>
        <BreadcrumLayout>
            <div class="flex">
                <a href="#" class="link-color"><u>Planning</u></a>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                </svg>
                <a href="#" class="link-color"><u>Food Orders</u></a></div>
        </BreadcrumLayout>
        <PageTitleLayout>
            <div class="w-full flex flex-wrap justify-between items-center">
                <h1 class="heading-color xl:text-4xl text-2xl font-bold text-left">Step 2: Order Details</h1>
                <div class="right-button">
                    <inertia-link :href="route('order-calculator')+'?order_id='+this.order_id" class="">
                        <button class="cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-0 rounded lg:mt-0 sm:mt-0">
                            BACK
                        </button>
                    </inertia-link>

                    <inertia-link :href="route('food-orders')" class="">
                        <button class="cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-0 rounded lg:mt-0 sm:mt-0">
                            CANCEL
                        </button>
                    </inertia-link>

                    <button @click="loadIsPrint" :disabled="!isLatestVersion" class="button-color text-white font-bold py-3 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 disabled:opacity-50">
                        PRINT
                    </button>

                    <button @click="NewVersionCreateFoodOrder" :disabled="!isLatestVersion" class="button-color text-white font-bold py-3 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 disabled:opacity-50">
                MAKE NEW VERSION
            </button>
                    <button :disabled="!isLatestVersion" @click="CreateFoodOrder" class="button-color text-white font-bold py-3 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 disabled:opacity-50">
                        NEXT
                    </button>
                </div>
            </div>

        </PageTitleLayout>

        <div class="lg:mb-0 mb-4 w-full mt-6 flex xl:px-10 px-5 items-center">
            <div class="flex">
<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="#0093d0">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span class="span-text font-bold pl-1">Confirm the order quantities for each delivery location:</span>
            </div>
            

            <select v-if="current_version > 1" class="mt-1 cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height float-right ml-auto" v-model="selected_version" @change="versionChanged" v-on:change="versionChange">
                <option value="" disabled>Select Version</option>
                <option v-for="n in current_version" :key="n" :value="n">Version {{ n }}                    
                </option>
            </select>
        </div>

        <div v-if="ignoredProductsCount() > 0" class="lg:mb-0 mb-4 w-full mt-6 flex xl:px-10 px-5" >
            <input type="checkbox" @click="filterIgnoredProdcuts()" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            <span class="span-text font-bold pl-1 ml-2" v-text="filterIgnoredProducts ? 'Hide ignored products' : 'Show ignored products'"></span>
        </div>


        <!-- Latest version -->

        <div v-for="(preferProduct, index) in preferProducts" :key="index" v-if="isLatestVersion">
            <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mx-10 mt-1">
                <h2 class="text-white text-lg font-bold w-11/12">
                    <!-- {{ preferProduct.offering.offering_name }} -- {{ index }} -->
                </h2>
                <a title="Add Products" href="#" @click="addProductsIngredientModalOpen(index)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                </a>
                <svg v-if="! isOpenOffering.includes(index)" @click="accordianShow(index)" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" @click="accordianHide(index)" class="h-6 w-6 text-white mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </header>

            <div v-if="isOpenOffering.includes(index)" class="flex flex-col mb-6 mx-10 my_table">
                <div class="overflow-x-auto">
                    <div class="align-middle inline-block min-w-full">
                        <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                            <table class="min-w-full">
                                <thead class="header-bg-color align-top">
                                    <tr>
                                      <th scope="col" class="w-10"></th>
                                        <th scope="col" class="w-1/5 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                          Ingredients
                                        </th>

                                        <th scope="col" class="w-1/5 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                            Preferred Products
                                        </th>
                                        <th scope="col" class="w-1/12 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Distributor
                                        </th>
<!--                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">-->
<!--                                            Student Count-->
<!--                                        </th>-->

                                        <th  scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative cursor-pointer">
                                            <div @click="showNeededCases()">
                                                Amount Needed
                                                <span class="absolute right-0 w-fit cursor-pointer">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black mr-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                    </svg>
                                                </span>
                                            </div>

                                            <div v-show="neededCasesVisible" class="absolute bg-[#38558e] min-w-[160px] left-0 text-white z-10 py-[14px] px-[15px] shadow-shadowb">
                                                <label  class="cursor-pointer" >
                                                <input type="radio"   
                                                names="measurementOption" 
                                                v-model="showByDefault"
                                                value="default"
                                                @click="defaultHighestNeededRecipeUom" class="cursor-pointer">
                                                Default</label><br>

                                                
                                                <label   class="cursor-pointer">
                                                    <input type="radio"   
                                                    names="measurementOption"
                                                value="packs"
                                                v-model="showByDefault"
                                                @click="packWise" class="cursor-pointer">
                                                    Packwise</label><br>
                                                
                                                <label class="cursor-pointer ">

                                                    <input type="radio" 
                                                    names="measurementOption" 
                                                value="cases"
                                                v-model="showByDefault"
                                                @click="caseWiseMeasurement" class="cursor-pointer">
                                                    
                                                    Casewise</label><br>
                                            </div>
                                        </th>

                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            On Hand
                                        </th>

                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Case(s)
                                        </th>

                                       <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Estimated Order Amount
                                        </th>

                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            &nbsp;
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Oddd row -->
                                <template v-for="(preferProduct, product) in preferProduct.offering.products " :key="product">
                                    <tr class="bg-white" :class="{'bg-gray-300 opacity-70': preferProduct.ignoredCheckboxShow || preferProduct.needed_recipe_amount < preferProduct.needed}" v-if="!preferProduct.hideFromFilter">
                                        <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                                            <input v-if="preferProduct.ignoredCheckboxShow" v-model="preferProduct.ignored" type="checkbox" class="mr-3" @click="ignoreProdcut(index, product, preferProduct)">
                                        </td>
                                      <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color truncate max-w-[220px]" >
                                        
                                            <a v-if="preferProduct.ingredient_id" target="_blank" :href="route('ingredients-edit',{ ingredient: preferProduct.ingredient_id })" :title="preferProduct.ingredient_name"> {{ preferProduct.ingredient_name }}</a>                                            
                                        </td>

                                        <td class=" px-6 py-4 whitespace-nowrap text-base font-bold underline id-color truncate max-w-[220px]">
                                            <!-- Tyson-Frozen 1/4 Ib Beef Patty -->
                                            <a target="_blank" :href="route('products_edit',{ id: preferProduct.product_id })" :title="preferProduct.product_name"> {{ preferProduct.product_name }}
                                            </a>

                                        </td>
                                        <td class="py-4 whitespace-nowrap text-base text-color td-background-color">
                                           
                                            <div class="flex gap-2">
                                                <div @change="changeDistributor(index, product,preferProduct.distributor_id, preferProduct)" class="relative focus:outline-none sm:w-50 w-50 xl:pl-4 pl-0 xl:mt-0 mt-4">                                                   

                                                    <select v-model="preferProduct.distributor_id" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base text-gray-400">
                                                        <option value="" :disabled="true">Select Distributor</option>
                                                        <option v-for="(i) in sortedItems" :value="i.id">
                                                            {{ getDistributorName(i, preferProduct.distributors) }}
                                                        </option>
                                                    </select>
                                                    
                                                    <div v-show="preferProduct.distributor_error" class="validation_error_msg">Please select distributor.</div>

                                                    <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none"><i class="fa fa-sort-desc" aria-hidden="true"></i></div>

                                                    


                                                </div>
                                                <button v-on:click="openDistributorPopup(index, product)" class="text-xl font-bold id-color">+</button>
                                            </div>

                                        </td> 

                                        <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color font-bold relative" >                                            
                                            <div class="flex items-center gap-1">
                                                
                                            <div>
                                            <span class="" v-if="preferProduct.extra_product && !['packs', 'cases'].includes(preferProduct.recipe_amount_uom)" >
                                                <a class="id-color">Added : </a>
                                                <input type="number" min="0" step="0.01" @change="changeNeededAmount(preferProduct)"  v-model="preferProduct.needed_recipe_amount" class="border border-gray-300 rounded-lg p-2 mt-1" placeholder="Enter Needed Amount" >
                                                
                                            </span>
                                            <span class="" v-else-if="preferProduct.extra_product && ['packs', 'cases'].includes(preferProduct.recipe_amount_uom) ">
                                                <a class="id-color">Added : </a>
                                                {{formattedValue( preferProduct.needed_recipe_amount) }}
                                                
                                            </span>
                                            <span v-else>
                                                {{formattedValue( preferProduct.needed_recipe_amount) }}
                                            </span>

                                            <span v-if="!['packs', 'cases'].includes(preferProduct.recipe_amount_uom) && ($helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom' && preferProduct.recipe_amount_uom != '-' )" class="id-color cursor-pointer font-extrabold" :title="preferProduct.recipe_amount_uom">
                                               ?
                                               &nbsp; 
                                            </span>
                                            <span v-if="['packs', 'cases'].includes(preferProduct.recipe_amount_uom)" class="" >
                                                &nbsp; 
                                               {{ preferProduct.recipe_amount_uom }}
                                               
                                            </span>


                                            </div>


                                            <select v-if=" !['packs', 'cases'].includes(preferProduct.recipe_amount_uom) && ($helpers.uomType(preferProduct.recipe_amount_uom) != 'Custom' || preferProduct.recipe_amount_uom == '-')"
                                            v-model="preferProduct.recipe_amount_uom" 
                                            @change="changeUom(preferProduct)" class="mt-1 cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height">
                                                <option value="" disabled>Select UOM</option>
                                                <optgroup label="Weight" v-if="umoWeightArray.includes(preferProduct.nutrition_facts_weight_uom) && preferProduct.nutrition_facts_weight > 0">
                                                    <option v-for="uom in umoWeightArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Volume" v-if="umoVolumArray.includes(preferProduct.nutrition_facts_volume_uom) && preferProduct.nutrition_facts_volume > 0">
                                                    <option v-for="uom in umoVolumArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Unit" v-if="preferProduct.nutrition_facts_unit > 0">
                                                    <option value="Each">Each</option>
                                                    <option value="Count">Count</option>
                                                    <option value="Piece">Piece</option>
                                                </optgroup>
                                            </select>
                                           

                                            <select v-if="!['packs', 'cases'].includes(preferProduct.recipe_amount_uom) && ($helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom' && preferProduct.recipe_amount_uom != '-')" v-model="preferProduct.recipe_amount_custom_uom" @change="changeCustomUom(preferProduct)" class="mt-1 cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height">
                                                <option value="" disabled>Select Custom UOM</option>
                                                <optgroup label="Weight" >
                                                    <option v-for="uom in umoWeightArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Volume" v-if="umoVolumArray.includes(preferProduct.default_cuom?.unit_type)">
                                                    <option v-for="uom in umoVolumArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Unit" v-if="['Each', 'Count', 'Piece'].includes(preferProduct.default_cuom?.unit_type)">
                                                    <option value="Each">Each</option>
                                                    <option value="Count">Count</option>
                                                    <option value="Piece">Piece</option>
                                                </optgroup>
                                            </select>
                                            </div>
                                        </td>

                                        <td class="px-6 py-4 whitespace-nowrap text-base text-color flex items-center">
                                            
                                            <input v-model="preferProduct.needed" @change="changeOrderValue(index, product, preferProduct)" type="text" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-white sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2 mt-1">
                                            <!-- {{ preferProduct.recipe_amount_uom }} -->
                                            {{ $helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom' && !['cases', 'packs'].includes(preferProduct.recipe_amount_uom) ? preferProduct.recipe_amount_custom_uom : preferProduct.recipe_amount_uom }}
                                        </td>
                                         <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                                            {{preferProduct.case_quantity }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                                            {{ estimatedNeeded(preferProduct.needed_recipe_amount, preferProduct.needed) }} 

                                            
                                            
                                            {{ $helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom' && !['cases', 'packs'].includes(preferProduct.recipe_amount_uom) ? preferProduct.recipe_amount_custom_uom : preferProduct.recipe_amount_uom }}


                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-base text-color id-color font-bold flex">                                            
                                            <div  v-if="preferProduct.not_convertable" class=" right-0 top-7">
                                                <a title="Case information missing" target="_blank" :href="route('products_edit',{ id: preferProduct.product_id })">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="#cb0000"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                                                </a>
                                            </div>
                                            <CaseInfo :preferProduct="preferProduct" :all_distributors="all_distributors"  update-case-info="updateCaseInfo(index, product, $event)"
                                            :ind="index" :prod="product"
                                            @update-distributors="updateProductDistributors"
                                            ></CaseInfo>
                                        </td>

                                    </tr>
                                </template>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-for="(preferProduct, index) in preferProductsVersion" :key="index" v-if="!isLatestVersion">
            <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg mx-10 mt-1">
                <h2 class="text-white text-lg font-bold w-11/12">
                <!-- {{ preferProduct.offering.offering_name }} -->
                </h2>
                <!-- <a title="Add Products" href="#" @click="addProductsIngredientModalOpen(index)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                </a> -->
                <svg v-if="! isOpenOffering.includes(index)" @click="accordianShow(index)" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" @click="accordianHide(index)" class="h-6 w-6 text-white mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </header>

            <div v-if="isOpenOffering.includes(index)" class="flex flex-col mb-6 mx-10 my_table">
                <div class="overflow-x-auto">
                    <div class="align-middle inline-block min-w-full">
                        <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                            <table class="min-w-full">
                                <thead class="header-bg-color align-top">
                                    <tr>
                                      <th scope="col" class="w-10"></th>
                                        <th scope="col" class="w-1/5 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                          Ingredients
                                        </th>

                                        <th scope="col" class="w-1/5 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                            Preferred Products
                                        </th>
                                        <th scope="col" class="w-1/12 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Distributor
                                        </th>

                                        <th  scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative cursor-pointer">
                                            <div @click="showNeededCases()">
                                                Amount Needed
                                                <!-- <span class="absolute right-0 w-fit cursor-pointer">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-black mr-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                    </svg>
                                                </span> -->
                                            </div>

                                            <div v-show="neededCasesVisible" class="absolute bg-[#38558e] min-w-[160px] left-0 text-white z-10 py-[14px] px-[15px] shadow-shadowb">
                                                <label  class="cursor-pointer" >
                                                <input type="radio"   
                                                names="measurementOption" 
                                                v-model="showByDefault"
                                                value="default"
                                                @click="defaultHighestNeededRecipeUom" class="cursor-pointer">
                                                Default</label><br>

                                                
                                                <label   class="cursor-pointer">
                                                    <input type="radio"   
                                                    names="measurementOption"
                                                value="packs"
                                                v-model="showByDefault"
                                                @click="packWise" class="cursor-pointer">
                                                    Packwise</label><br>
                                                
                                                <label class="cursor-pointer ">

                                                    <input type="radio" 
                                                    names="measurementOption" 
                                                value="cases"
                                                v-model="showByDefault"
                                                @click="caseWiseMeasurement" class="cursor-pointer">
                                                    
                                                    Casewise</label><br>
                                            </div>
                                        </th>

                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            On Hand
                                        </th>

                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Case(s)
                                        </th>

                                       <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Estimated Order Amount
                                        </th>

                                        <!-- <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            &nbsp;
                                        </th> -->

                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Oddd row -->
                                <template v-for="(preferProduct, product) in preferProduct.offering.products " :key="product">
                                    <tr class="bg-white" :class="{'bg-gray-300 opacity-70': preferProduct.ignoredCheckboxShow || preferProduct.needed_recipe_amount < preferProduct.needed}" v-if="!preferProduct.hideFromFilter">
                                        <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                                            <input v-if="preferProduct.ignoredCheckboxShow" v-model="preferProduct.ignored" type="checkbox" class="mr-3" @click="ignoreProdcut(index, product, preferProduct)">
                                        </td>
                                      <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color truncate max-w-[220px]" >
                                        
                                            <a v-if="preferProduct.ingredient_id" target="_blank" :href="route('ingredients-edit',{ ingredient: preferProduct.ingredient_id })" :title="preferProduct.ingredient_name"> {{ preferProduct.ingredient_name }}</a>

                                            
                                        </td>

                                        <td class=" px-6 py-4 whitespace-nowrap text-base font-bold underline id-color truncate max-w-[220px]">
                                            <!-- Tyson-Frozen 1/4 Ib Beef Patty -->
                                            <a target="_blank" :href="route('products_edit',{ id: preferProduct.product_id })" :title="preferProduct.product_name"> {{ preferProduct.product_name }}
                                            </a>

                                        </td>
                                        <td class="py-4 whitespace-nowrap text-base text-color td-background-color">
                                           
                                            <div class="flex gap-2">

                                                <div change="changeDistributor(index, product,preferProduct.distributor_id, preferProduct)" class="relative focus:outline-none sm:w-50 w-50 xl:pl-4 pl-0 xl:mt-0 mt-4">

                                                    <select disabled="disabled" v-model="preferProduct.distributor_id" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base text-gray-400">
                                                        <option value="" :disabled="true">Select Distributor</option>
                                                        <option v-for="(i) in sortedItems" :value="i.id">
                                                            {{ getDistributorName(i, preferProduct.distributors) }}
                                                        </option>
                                                    </select>
                                                    <div v-show="preferProduct.distributor_error" class="validation_error_msg">Please select distributor.</div>

                                                    <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none"><i class="fa fa-sort-desc" aria-hidden="true"></i></div>

                                                    


                                                </div>
                                                <!-- <button v-on:click="openDistributorPopup(index, product)" class="text-xl font-bold id-color">+</button> -->

                                                
                                            </div>

                                        </td> 

                                        <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color font-bold relative" >
                                            <div class="flex  items-center gap-1">
                                            <div>
                                            <span class="" v-if="preferProduct.extra_product && !['packs', 'cases'].includes(preferProduct.recipe_amount_uom)" >
                                                <a class="id-color">Added : </a>
                                                <input type="number" disabled="disabled" min="0" step="0.01" @change="changeNeededAmount(preferProduct)"  v-model="preferProduct.needed_recipe_amount" class="border border-gray-300 rounded-lg p-2 mt-1" placeholder="Enter Needed Amount" >
                                                
                                            </span>
                                            <span class="" v-else-if="preferProduct.extra_product && ['packs', 'cases'].includes(preferProduct.recipe_amount_uom) ">
                                                <a class="id-color">Added : </a>
                                                {{formattedValue( preferProduct.needed_recipe_amount) }}
                                                
                                            </span>
                                            <span v-else>
                                                {{formattedValue( preferProduct.needed_recipe_amount) }}
                                            </span>

                                            <span v-if="['packs', 'cases'].includes(preferProduct.recipe_amount_uom) || $helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom'">
                                               &nbsp; {{ preferProduct.recipe_amount_uom }}
                                            </span>
                                            </div>


                                            <select disabled="disabled" v-if=" !['packs', 'cases'].includes(preferProduct.recipe_amount_uom) && $helpers.uomType(preferProduct.recipe_amount_uom) != 'Custom'"
                                            v-model="preferProduct.recipe_amount_uom" 
                                            @change="changeUom(preferProduct)" class="mt-1 cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height">
                                                <option value="" disabled>Select UOM</option>
                                                <optgroup label="Weight" v-if="umoWeightArray.includes(preferProduct.nutrition_facts_weight_uom) && preferProduct.nutrition_facts_weight > 0">
                                                    <option v-for="uom in umoWeightArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Volume" v-if="umoVolumArray.includes(preferProduct.nutrition_facts_volume_uom) && preferProduct.nutrition_facts_volume > 0">
                                                    <option v-for="uom in umoVolumArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Unit" v-if="preferProduct.nutrition_facts_unit > 0">
                                                    <option value="Each">Each</option>
                                                    <option value="Count">Count</option>
                                                    <option value="Piece">Piece</option>
                                                </optgroup>
                                            </select>

                                            <select disabled="disabled" v-if="!['packs', 'cases'].includes(preferProduct.recipe_amount_uom) && $helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom'" v-model="preferProduct.recipe_amount_custom_uom" @change="changeCustomUom(preferProduct)" class="mt-1 cursor-pointer shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height">
                                                <option value="" disabled>Select Custom UOM</option>
                                                <optgroup label="Weight" >
                                                    <option v-for="uom in umoWeightArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Volume" v-if="umoVolumArray.includes(preferProduct.default_cuom?.unit_type)">
                                                    <option v-for="uom in umoVolumArray" :value="uom">{{uom}}</option>
                                                </optgroup>

                                                <optgroup label="Unit" v-if="['Each', 'Count', 'Piece'].includes(preferProduct.default_cuom?.unit_type)">
                                                    <option value="Each">Each</option>
                                                    <option value="Count">Count</option>
                                                    <option value="Piece">Piece</option>
                                                </optgroup>
                                            </select>


                                            <!-- <div  v-if="preferProduct.not_convertable" class="absolute right-0 top-7">
                                                <a title="Unit of measure mismatch" target="_blank" :href="route('products_edit',{ id: preferProduct.product_id })">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="#cb0000"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                                                </a>
                                            </div> -->
                                            </div>
                                        </td>

                                        <td class="px-6 py-4 whitespace-nowrap text-base text-color flex items-center">
                                        
                                            <input disabled="disabled" v-model="preferProduct.needed" @change="changeOrderValue(index, product, preferProduct)" type="text" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-white sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">

                                            <!-- {{ preferProduct.recipe_amount_uom }} -->
                                            {{ $helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom' ? preferProduct.recipe_amount_custom_uom : preferProduct.recipe_amount_uom }}
                                        </td>
                                         <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                                            {{preferProduct.case_quantity }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                                            {{ estimatedNeeded(preferProduct.needed_recipe_amount, preferProduct.needed) }} {{ $helpers.uomType(preferProduct.recipe_amount_uom) == 'Custom' ? preferProduct.recipe_amount_custom_uom : preferProduct.recipe_amount_uom }}
                                        </td>
                                        <!-- <td class="px-6 py-4 whitespace-nowrap text-base text-color id-color font-bold ">
                                            <CaseInfo :preferProduct="preferProduct" :all_distributors="all_distributors"  update-case-info="updateCaseInfo(index, product, $event)"
                                            :ind="index" :prod="product"
                                            @update-distributors="updateProductDistributors"
                                            ></CaseInfo>
                                        </td> -->

                                    </tr>
                                </template>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p>
        </p>
        <div class="bottom_button w-full sm:flex lg:flex-nowrap flex-nowrap lg:justify-end items-center  mb-6  px-10 mt-6">
            <inertia-link  :href="route('order-calculator')+'?order_id='+this.order_id" class="">
                <button class="cancel-button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6  ml-0 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                    BACK
                </button>
            </inertia-link>
            
            <button @click="NewVersionCreateFoodOrder" class="button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10 disabled:opacity-50" :disabled="!isLatestVersion">
                MAKE NEW VERSION
            </button>

            <button @click="CreateFoodOrder" class="button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10 disabled:opacity-50" :disabled="!isLatestVersion">
                NEXT
            </button>
        </div>

        <!-- <attach-distributor v-if="showDistributorPopup" @close="showDistributorPopup = false"
            :all_distributors="filteredDistributors" :product="product"  @attach-distributor-item="addDistributorItem">
        </attach-distributor> -->

        <CreateDistributor v-if="showDistributorPopup" @close="showDistributorPopup = false" @create-new-distributor="createNewDistributor" />
    </default-layout>


    <div v-show="false">
        <PrintFoodOrder :preferProducts="preferProducts" :formattedValue="formattedValue" :estimatedNeeded="estimatedNeeded" :food_order_name="food_order_name">
        </PrintFoodOrder>
    </div>

    <jet-dialog-modal :max-width="'4/5'" :show="addProductsModal" @close="addProductsModal = false" >
        <template #title>
            <div class="flex justify-between items-center ">
            Search products to Add/Attach with ingredient
                <div class="relative md:w-56 ">
                    <input class="border-2 border-gray-300 bg-white h-10 px-3 pr-10 rounded-lg text-sm focus:outline-none w-full" type="search" name="search_term" placeholder="Search" v-model="search_term" @keyup.enter="productSearchScriptModal">
                    <button type="button" class="absolute right-0 top-0 mt-2 mr-4 outline-none" @click="productSearchScriptModal"><i class="fa fa-search" aria-hidden="true"></i></button>
                </div>
            </div>
        </template>
        <template #content>
            <TableIndexLayout>
                <div class="-my-2">
                <div class="py-2 align-middle inline-block px-2 w-full">
                    <div class="shadow overflow-auto max-height">
                    <table class="min-w-full">
                        <thead class="header-bg-color">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">Ingredient NAME</th>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">PRODUCT NAME</th>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">Source</th>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">MANUFACTURER</th>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">MFG#</th>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">CN#</th>
                            <!-- <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">Needed</th>
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">UOM</th> -->
                            <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Odd row -->
                        <tr v-if="!searched_products.length" class="bg-white">
                            <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="6">No Product Found</td>
                        </tr>
                        <tr v-for="(prod,index) in searched_products" :class="{'bg-white':index%2 == 0, 'tr-background-color':index%2 != 0}" class="cursor-pointer" >
                            <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                            <div class="tooltip">
                                <div class="trim_text">{{prod.ingredient_name}}</div>
                                <div class="top">
                                {{prod.ingredient_name}}
                                <i></i>
                                </div>
                            </div>
                            </td>

                            <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                            <div class="tooltip">
                                <div class="trim_text">{{prod.name}}</div>
                                <div class="top">
                                {{prod.name}}
                                <i></i>
                                </div>
                            </div>
                            </td>

                            <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                            {{prod.tenant_name}}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                            {{prod.manufacturer}}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                            {{prod.manufacturer_sku}}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                            {{prod.cn_code}}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold">
                            <button type="button" class="" @click="addProductsAddScript(prod, index);">
                                <i class="fa fa-plus pr-3" aria-hidden="true"></i>
                            </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </TableIndexLayout>
        </template>
        <template #footer>
            <jet-secondary-button @click="addProductsModal = false">Close</jet-secondary-button>
        </template>
    </jet-dialog-modal>




    </template>


    <script>
    import DefaultLayout from "@/Layouts/DefaultLayout";
    import Welcome from "@/Jetstream/Welcome";
    import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
    import PageTitleLayout from "@/Pages/Common/PageTitle";
    import TableFilterLayout from "@/Pages/Common/TableFilters";
    import TableIndexLayout from "@/Pages/Common/TableIndex";
    import PrintFoodOrder from "@/Pages/FoodOrders/PrintEditFoodOrderStep-3";
    import JetDialogModal from '@/Jetstream/DialogModal';
    import JetButton from '@/Jetstream/Button';
    import JetSecondaryButton from '@/Jetstream/SecondaryButton';
    import Ingredients from "../Ingredients/Ingredients.vue";
    import AttachDistributor from '@/Pages/Products/Popup/AttachDistributor';
    import CreateDistributor from '@/Pages/FoodOrders/Distributors/CreateDistributor';
    import CaseInfo from '@/Pages/FoodOrders/Distributors/CaseInfo';
import axios from "axios";
import { includes } from "lodash";
    export default {
        data() {
            return {
                currentPreferredProduct: null,
                showByDefault: '',
                originalPreferProducts: Object.assign({}, this.originalPreferProductss) ,
                isOpenOffering: [Object.keys(this.originalPreferProductss)[0]],
                inputValue: '',
                umoVolumArray: ['Gallon',  'Quart', 'Pint', 'Cup', 'Fluid Ounce', 'Tablespoon', 'Teaspoon', 'Millilitre', 'Litre'],
                umoWeightArray: ['Ounce', 'Gram','LB','Kilogram', 'Milligram'],
                neededCasesVisible: false,
                preferProducts: [],
                preferProductsVersion: [],
                
                filterIgnoredProducts: false,
                addProductsModal:false,
                searched_products:[],
                search_term:'',
                currentOffering: '',
                addProdcutbuttonClicked: false,
                clickedRowIndex: null,
                showDistributorPopup: false,
                currentProductKey :null,
                currentProductIndex : null,
                activeProductId : null,
                filteredDistributors: [],
                current_version: this.order.current_version,
                selected_version: this.order.current_version,
            }
        },

        props: ['originalPreferProductss', 'order_id', 'food_order_name', 'food_create_type', 'food_create_id', 'all_distributors', 'order'],

        components: {
          Ingredients,
            DefaultLayout,
            Welcome,
            BreadcrumLayout,
            PageTitleLayout,
            TableFilterLayout,
            TableIndexLayout,
            PrintFoodOrder,

            JetButton,
            JetSecondaryButton,
            JetDialogModal,
            AttachDistributor,
            CreateDistributor,
            CaseInfo
        },

        mounted() {
            // this.preferProducts = this.originalPreferProducts;
            this.convertByDefault();
            this.hideIgnoredOnProdcut;
        },

        computed: {
            isLatestVersion() {
                return this.selected_version == this.current_version;
            },
            sortedItems() {
                return [...this.all_distributors].sort((a, b) =>
                a.name.localeCompare(b.name)
                );
            },
            hideIgnoredOnProdcut() {
                const preferProducts = this.preferProducts;
                console.log(this.preferProducts);
                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        if(preferProduct.needed_recipe_amount < preferProduct.needed){
                            preferProduct.ignored = true;
                            preferProduct.hideFromFilter = true;
                            preferProduct.ignoredCheckboxShow = true;
                        }
                    });
                });
            },
        },

        methods: {

            versionChanged() {
                // console.log('versionChanged ');
                this.hideShowLoader('show');

                axios.get('/get-food-order-items/'+this.order_id+'?version='+this.selected_version)
                        .then((response)=>{
                this.hideShowLoader('hide');
                // console.log('versionChanged response', response.data);
                this.convertByDefaultVersion(response.data);
                })
                .catch(error => {
                    this.hideShowLoader('hide');
                    console.error(error);
                });
            },
            getDistributorName(distributor, preferProductDistributors) {
                console.log('distributor', preferProductDistributors);
                // const found = preferProductDistributors.values().find(d => d.id === distributor.id);
                const found = Object.values(preferProductDistributors).find(d => d.id === distributor.id);
                console.log('getDistributorName found', found, distributor.id);
                return found ? found.name + ' (' + found.case_cost + ')'  : distributor.name;
            },

            convertGroupByIngredient(){
                let preferProducts = this.preferProducts; 
                // console.log('convertGroupByIngredient called start', preferProducts);
                let ingredientGroup = {};
                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        if(!ingredientGroup[preferProduct.ingredient_id]){
                            ingredientGroup[preferProduct.ingredient_id] = [];
                        }
                        ingredientGroup[preferProduct.ingredient_id].push(preferProduct);
                    });
                });

                let p = {};

                // merge ingrediant group back to preferProducts
                Object.keys(ingredientGroup).forEach((index) => {
                    // console.log('ingredientGroup[index] test in', ingredientGroup[index]);
                    let a = this.convertGroupProducts(ingredientGroup[index]);
                    // console.log('ingredientGroup[index] test out', a);
                   p[a.order_item_id] = a;
                });
                // console.log('convertGroupByIngredient final p final ', p);

                            // ingredientGroup[preferProduct.ingredient_id] = [];
                // console.log('convertGroupByIngredient final p ', p);

                this.preferProducts = Object.assign({}, this.preferProducts);

                let preferProductss = this.preferProducts;
                Object.keys(this.preferProducts).forEach((index) => {
                    console.log('convertGroupByIngredient final test in', preferProductss[index]['offering']['products'], this.preferProducts[index]);
                    console.log('convertGroupByIngredient final test in', preferProductss[index]['offering']['products']);
                    const safeP = JSON.parse(JSON.stringify(p));
                    this.preferProducts[index]['offering']['products'] = safeP;
                    // console.log('convertGroupByIngredient final test out', this.preferProducts[index]['offering']['products'], safeP);
                });
                // this.preferProducts = preferProductss;
                // console.log('convertGroupByIngredient final this.preferProducts', this.preferProducts); 
                
                this.originalPreferProducts = Object.assign({}, this.preferProducts); 
                this.convertByDefault(false);

            },

            convertGroupProducts(products){
                let weight=0 , volumn=0, unit=0, student_count=0;
                let weightUnit = '', volumnUnit = '';
                let p = {};
                let isCustom = false;

                // console.log('convertGroupByIngredient convertGroupProducts products', products);



                products.forEach((product) => {
                    // console.log('convertGroupByIngredient convertGroupProducts product', product);
                    if(product.default_needed_recipe_amount > 0){
                        p = Object.assign({}, product);
                        student_count +=  product.student_count;
                        if(this.$helpers.uomType(product.default_recipe_amount_uom) === 'Weight'){
                            let amt = this.$conversions.weight(product.default_needed_recipe_amount, product.default_recipe_amount_uom, 'Gram');
                            weight += amt;
                            weightUnit = 'Gram';
                            console.log('convertGroupByIngredient intermediate weight default_recipe_amount_uom weight in ', amt, weight, weightUnit);
                        } else if(this.$helpers.uomType(product.default_recipe_amount_uom) === 'Volume'){
                            let amt = this.$conversions.volume(product.default_needed_recipe_amount, product.default_recipe_amount_uom, 'Teaspoon');
                            volumn += amt;
                            volumnUnit = 'Teaspoon';
                            console.log('convertGroupByIngredient intermediate weight default_recipe_amount_uom volumn in ', amt, volumn, volumnUnit);
                        } else if(this.$helpers.uomType(product.default_recipe_amount_uom) === 'Unit'){
                            unit += product.default_needed_recipe_amount;
                        } else if(this.$helpers.uomType(product.default_recipe_amount_uom) === 'Custom'){
                            isCustom = true;
                            if(this.$helpers.uomType(product.default_recipe_amount_custom_uom) === 'Weight'){
                                let amt = this.$conversions.weight(product.default_needed_recipe_amount, product.default_recipe_amount_custom_uom, 'Gram');
                                weight += amt;
                                weightUnit = 'Gram';
                            } else if(this.$helpers.uomType(product.default_recipe_amount_custom_uom) === 'Volume'){
                                let amt = this.$conversions.volume(product.default_needed_recipe_amount, product.default_recipe_amount_custom_uom, 'Teaspoon');
                                volumn += amt;
                                volumnUnit = 'Teaspoon';
                            } else if(this.$helpers.uomType(product.default_recipe_amount_custom_uom) === 'Unit'){
                                unit += product.default_needed_recipe_amount;
                            }
                        }                        
                    }
                });
                let newRecipeAmount = 0;
                let newRecipeAmountUnit = '';
                // console.log('convertGroupByIngredient intermediate weight', weight, volumn, unit, products);
                if(volumn > 0){
                     newRecipeAmount = volumn;
                     newRecipeAmountUnit = volumnUnit;
                    if(weight > 0){
                        newRecipeAmount = newRecipeAmount + this.$conversions.weightToVolume(p, weight, weightUnit, volumnUnit);
                    }
                    if(unit > 0){
                        let newRecipeAmount = newRecipeAmount + unit;
                    }
                } else if(weight > 0){
                    newRecipeAmount = weight;
                    newRecipeAmountUnit = weightUnit;
                    if(unit > 0){
                        let newRecipeAmount = newRecipeAmount + unit;
                    }
                } else if(unit > 0){
                    newRecipeAmount = unit;
                    newRecipeAmountUnit = 'Each';
                }
                p.student_count = student_count;
                p.needed_recipe_amount = p.default_needed_recipe_amount = newRecipeAmount;
                if(this.$helpers.uomType(p.default_recipe_amount_uom) === 'Custom'){
                    p.recipe_amount_custom_uom = p.default_recipe_amount_custom_uom = newRecipeAmountUnit;
                } else {
                    p.recipe_amount_uom = p.default_recipe_amount_uom = newRecipeAmountUnit;
                }
                return p;

            },

            convertByDefault(isLoop = true){

                // console.log('convertByDefault called', this.current_version);

                this.preferProducts = this.originalPreferProducts;
                

                this.neededCasesVisible = false;
                const preferProducts = this.preferProducts;

                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {

                        console.log("productproductproduct asdf",preferProducts[index]['offering']['products'][product] );
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        if(!['packs', 'cases'].includes(preferProduct.recipe_amount_uom)){                        
                        
                        if(preferProduct.needed_recipe_amount > 0){
                            preferProduct.needed_recipe_amount = Number(preferProduct.needed_recipe_amount).toFixed(2);
                        }
                        if(preferProduct.default_recipe_amount_uom > 0){
                            preferProduct.default_recipe_amount_uom = Number(preferProduct.default_recipe_amount_uom).toFixed(2);
                        }
                        

                        if(preferProduct.created_at == preferProduct.updated_at && this.current_version == 0)
                        {
                            
                            preferProduct.needed_recipe_amount = Number(preferProduct.default_needed_recipe_amount).toFixed(2);
                            preferProduct.recipe_amount_uom = preferProduct.default_recipe_amount_uom;
                            preferProduct.needed = 0;

                            const oldUomType = this.$helpers.uomType(preferProduct.recipe_amount_uom);
                            const oldUom = preferProduct.recipe_amount_uom;
                            let initNeedeAmount = preferProduct.needed_recipe_amount;
                            if(oldUomType === 'Unit'){
                                if(initNeedeAmount > 0){
                                    initNeedeAmount = Math.ceil(initNeedeAmount);
                                }
                            }

                            this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct);
                            preferProduct.case_quantity = this.calculateCaseQuantityForProduct(preferProduct);   
                                                   
                        } 
                        const result = this.calculateCaseQuantityForProduct(preferProduct);
                        preferProduct.not_convertable = (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && result <= 0);                    
                        this.setDefaultCaseQuantity(preferProduct);
                        
                    }
                    });
                });
                if(isLoop && this.current_version == 0){
                    console.log('convertByDefault called after ', this.preferProducts);
                this.convertGroupByIngredient();
                }
            },

            setDefaultCaseQuantity(preferProduct){
                console.log('setDefaultCaseQuantity', preferProduct.case_quantity);
                if (!Number.isFinite(preferProduct.case_quantity) || preferProduct.case_quantity <= 1) {
                    preferProduct.case_quantity = 1;
                    if(preferProduct.needed > 0){ 
                        if(preferProduct.needed_recipe_amount > 0){
                            if(preferProduct.needed_recipe_amount <= preferProduct.needed){
                                preferProduct.case_quantity = 0;
                            }
                        }
                    }
                }
            },
            
            convertByDefaultVersion(data){
                this.preferProductsVersion = data;
                const preferProducts = this.preferProductsVersion;

                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        // console.log("productproductproduct",preferProducts[index]['offering']['products'][product] );
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        if(!['packs', 'cases'].includes(preferProduct.recipe_amount_uom)){
                        // console.log('convertByDefault', preferProduct);
                        if(preferProduct.needed_recipe_amount > 0){
                            preferProduct.needed_recipe_amount = Number(preferProduct.needed_recipe_amount).toFixed(2);
                        }
                        if(preferProduct.default_recipe_amount_uom > 0){
                            preferProduct.default_recipe_amount_uom = Number(preferProduct.default_recipe_amount_uom).toFixed(2);
                        }                        

                        if(preferProduct.created_at == preferProduct.updated_at)
                        {
                            preferProduct.needed_recipe_amount = Number(preferProduct.default_needed_recipe_amount).toFixed(2);
                            preferProduct.recipe_amount_uom = preferProduct.default_recipe_amount_uom;
                            preferProduct.needed = 0;

                            const oldUomType = this.$helpers.uomType(preferProduct.recipe_amount_uom);
                            const oldUom = preferProduct.recipe_amount_uom;
                            let initNeedeAmount = preferProduct.needed_recipe_amount;
                            if(oldUomType === 'Unit'){
                                if(initNeedeAmount > 0){
                                    initNeedeAmount = Math.ceil(initNeedeAmount);
                                }
                            }

                            this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct);
                            preferProduct.case_quantity = this.calculateCaseQuantityForProduct(preferProduct);    
                            this.setDefaultCaseQuantity(preferProduct);                        
                        }
                    }
                    });
                });
            },

            calculateDistributorPrice(preferProduct) {
                const pProductRecipeAmountUom = preferProduct.recipe_amount_uom;
                    if(preferProduct.distributor_id != null && preferProduct.distributor_id != ''){
                        if( pProductRecipeAmountUom == 'packs' || pProductRecipeAmountUom == 'cases'){
                            console.log('pProductRecipeAmountUom', pProductRecipeAmountUom);
                            const originalProduct = preferProduct;
                            const oldUomType = this.$helpers.uomType(originalProduct.default_recipe_amount_uom);
                            const oldUom = originalProduct.default_recipe_amount_uom ;
                            let initNeedeAmount = originalProduct.default_needed_recipe_amount;
                            if(oldUomType === 'Unit'){
                                if(initNeedeAmount > 0){
                                    initNeedeAmount = Math.ceil(initNeedeAmount);
                                }
                            }
                            this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom,  preferProduct);
                            this.packWiseMeasurementOfProduct(preferProduct);

                            if(pProductRecipeAmountUom == 'cases'){
                                // if(preferProduct.not_convertable && preferProduct.not_convertable != true){
                                    const packs = preferProduct.distributors[preferProduct.distributor_id]['pack'];
                                    preferProduct.needed_recipe_amount =  Number(Math.ceil(preferProduct.needed_recipe_amount/packs)).toFixed(2);
                                    preferProduct.recipe_amount_uom = 'cases';
                                // }
                            }
                        }
                            const result = this.calculateCaseQuantityForProduct(preferProduct);
                            preferProduct.case_quantity = result;
                            this.setDefaultCaseQuantity(preferProduct);
                            preferProduct.not_convertable = (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && result <= 0);
                    }
            },

            addProductsIngredientModalOpen(offering) {
                this.currentOffering = offering;
                console.log('offerincurrentOfferingg', this.currentOffering);
                this.addProductsModal = true;
                this.searched_products = [];
                this.search_term ='';
            },

            productSearchScriptModal(){
                if(this.search_term == ""){
                    this.$toast.error('Error: Search value required!');
                }else{
                    this.addProdcutbuttonClicked = false;
                    this.clickedRowIndex = null;
                    let exist_products = [];
                    Object.keys(this.preferProducts[this.currentOffering].offering.products).forEach((value,index) => {
                        exist_products.push(this.preferProducts[this.currentOffering].offering.products[value].product_id);
                    });

                    this.hideShowLoader('show');

                    axios.post('/food-order-product-search-modal',{term:this.search_term,ex_ids:exist_products, is_all : this.is_all})
                            .then((response)=>{
                    this.hideShowLoader('hide');
                    this.searched_products = response.data;
                    })
                    .catch(error => {
                        this.hideShowLoader('hide');
                        console.error(error);
                    });
                }
            },

            hideShowLoader(types){
                if(types == 'show'){
                    document.getElementById('full_loader').style.display = 'flex';
                } else {
                    document.getElementById('full_loader').style.display = 'none';
                }
            },

            addProductsAddScript(product_array, index){
                // if(product_array.recipe_amount_uom != '' && product_array.needed_recipe_amount !=''){
                    const products = this.preferProducts[this.currentOffering].offering.products;
                    const firstProductId = Object.keys(products)[0]; // Get the first key in the products object
                    const offeringId = products[firstProductId].offering_id;
                    product_array.offering_id = offeringId;
                    // product_array.original_uom = product_array.recipe_amount_uom;
                    // product_array.original_needed_recipe_amount = product_array.needed_recipe_amount;
                    product_array.product_name = product_array.name;
                    product_array.default_needed_recipe_amount = product_array.original_needed_recipe_amount;
                    product_array.default_recipe_amount_uom = product_array.original_uom;

                    // console.log('product_array', product_array);

                    // console.log('thiscurrentOffering', this.currentOffering);
                    this.preferProducts[this.currentOffering].offering.products[product_array.id] = product_array;
                    this.originalPreferProducts[this.currentOffering].offering.products[product_array.id] = product_array;

                    this.searched_products.splice(index,1);

                    const oldUomType = this.$helpers.uomType(product_array.recipe_amount_uom);
                    const oldUom = product_array.recipe_amount_uom ;
                    let initNeedeAmount = product_array.needed_recipe_amount;
                    if(oldUomType === 'Unit'){
                        if(initNeedeAmount > 0){
                            initNeedeAmount = Math.ceil(initNeedeAmount);
                        }
                    }
                    this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, product_array);

                    var result = this.calculateCaseQuantityForProduct(product_array);
                    // console.log('result of calculate', result);

                    product_array.case_quantity = result;
                    this.setDefaultCaseQuantity(product_array);

                    if (product_array.distributor_id && result <= 0) {
                        product_array.not_convertable = true;
                    }

                    // console.log('addProductsAddScript', this.preferProducts);
                    // console.log('orginalPreferProducts', this.originalPreferProducts);
                    this.searched_products.splice(index,1);
                // }else{
                //     this.addProdcutbuttonClicked = true;
                //     this.clickedRowIndex = index;
                // }
            },

            loadIsPrint() {
                // this.$refs.CalendarPrint.getCalenderDays();
                setTimeout(function () {
                    var w = window.open("", "", "width=800,height=600");
                    w.document.write('<html><head><style type="text/css" media="print">');
                    w.document.write('* {-webkit-print-color-adjust: exact !important; color-adjust: exact !important; }.header,.left_part,.month_year{display:flex}body{font-family:Lato,sans-serif!important;padding:20px}.header{align-items:center;justify-content:space-between;padding:30px 0;width:100%}.month_year{background:rgba(30,67,127);border-radius:15px 15px 0 0;padding:16px 12px 10px;align-items:flex-end;justify-content:space-between;width:100%;box-sizing:border-box}.month_name{color:#fff;font-size:24px;font-weight:700}table.table{width:100%;border:none;line-height:1.2}table.table thead{background:#132d56}table.table thead th{color:#fff;vertical-align:bottom;padding:5px;border-right:2px solid #233b61;font-size:12px}table.table thead th:last-child{border-right:none}table.table tr.grey_bar td{background:#e8e8e8;border-right:2px solid #d9d9d9;border-bottom-color:#d9d9d9;padding:7px 5px 6px 10px;font-size:14px;color:#454545;font-weight:600;text-align:left}table.table tr td{font-size:11px;color:#454545;text-align:center;padding:20px 5px 10px;border-style:solid;border-color:#eee #eee #cecece;border-width:2px 2px 2px 0;line-height:1.1}table.table tr td:first-child{border-left:2px solid #eee}table.table tr td p{margin:0}table.table tr td p+p{margin-top:5px}@page{size:auto;margin:0}');
                    w.document.write('</style></head><body >');
                    w.document.write(document.getElementById('print_food_order').innerHTML);
                    w.document.write('</body></html>');
                    w.document.close();
                    w.focus();
                    w.print();
                    setTimeout(function () {
                        w.close();
                    }, 3000);
                }, 300);
            },

            ignoredProductsCount() {
                let count = 0;
                const preferProducts = this.preferProducts;
                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        // console.log("productproductproduct",preferProducts[index]['offering']['products'][product] );
                        const preferProduct = preferProducts[index]['offering']['products'][product];

                        if (preferProduct.ignored) {
                                count++;
                        }
                    });
                });

                return count;
            },

            estimatedNeeded(neededRecipeAmount, needed){

                let estimated_needed = neededRecipeAmount - (needed);
                    estimated_needed = estimated_needed > 0 ? estimated_needed : 0;

                return this.formattedValue(estimated_needed);
            // return this.formattedValue((neededRecipeAmount - (needed > neededRecipeAmount ? 0 : needed)));
            },

            showNeededCases() {
                this.neededCasesVisible = !this.neededCasesVisible;
            },

            ignoreProdcut(index, pIndex, pProdcut){
                const preferProduct = this.preferProducts[index]['offering']['products'][pIndex];
                if(!this.filterIgnoredProducts){
                    preferProduct.hideFromFilter = ! preferProduct.hideFromFilter;
                }
                preferProduct.ignored = ! preferProduct.ignored;
                preferProduct.distributor_error = false;
            },

            filterIgnoredProdcuts(){

                this.filterIgnoredProducts = ! this.filterIgnoredProducts;
                const preferProducts = this.preferProducts;
                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {

                        // console.log("productproductproduct",preferProducts[index]['offering']['products'][product] );
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        // console.log('preferProduct', preferProduct);

                        if(preferProduct.ignored && this.filterIgnoredProducts){
                                preferProduct.hideFromFilter = false;
                        }
                        if(preferProduct.ignored && !this.filterIgnoredProducts){
                            preferProduct.hideFromFilter = true;
                        }
                    });
                });
            },



            defaultHighestNeededRecipeUom() {
                this.neededCasesVisible = false;
                const preferProducts = this.preferProducts;
                // console.log("preferProductspreferProducts", this.preferProducts);

                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        // console.log("productproductproduct",preferProducts[index]['offering']['products'][product] );
                        const preferProduct = preferProducts[index]['offering']['products'][product];

                        preferProduct.needed_recipe_amount = Number( preferProduct.default_needed_recipe_amount).toFixed(2);
                        preferProduct.recipe_amount_uom = preferProduct.default_recipe_amount_uom;
                        preferProduct.needed = 0;

                        const oldUomType = this.$helpers.uomType(preferProduct.recipe_amount_uom);
                        const oldUom = preferProduct.recipe_amount_uom;
                        let initNeedeAmount = preferProduct.needed_recipe_amount;
                        if(oldUomType === 'Unit'){
                            if(initNeedeAmount > 0){
                                initNeedeAmount = Math.ceil(initNeedeAmount);
                            }
                        }
                        this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct);
                        preferProduct.case_quantity = this.calculateCaseQuantityForProduct(preferProduct);
                        this.setDefaultCaseQuantity(preferProduct);

                    });
                });
            },

            highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom, preferProduct) {
                // console.log('highestNeededRecipeAndUomOfProduct', initNeedeAmount, oldUomType, oldUom, preferProduct);
                preferProduct.recipe_amount_uom = oldUom ;
                preferProduct.needed_recipe_amount = Number(initNeedeAmount).toFixed(2);
                // console.log(initNeedeAmount, oldUomType, oldUom, preferProduct);
                if (oldUomType === 'Weight') {
                    for (let newUom of this.umoWeightArray) {
                        var newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, newUom);
                        if (newRecipeAmount >= 1) {
                            preferProduct.needed_recipe_amount = Number(newRecipeAmount).toFixed(2);
                            preferProduct.recipe_amount_uom = newUom;
                            break;
                        }
                    }
                }
                if (oldUomType === 'Volume') {
                    for (let newUom of this.umoVolumArray) {
                        var newRecipeAmount = this.$conversions.volume(initNeedeAmount, oldUom, newUom);
                        if (newRecipeAmount >= 1) {
                            preferProduct.needed_recipe_amount = Number(newRecipeAmount).toFixed(2);
                            preferProduct.recipe_amount_uom = newUom;
                            break;
                        }
                    }
                }
            },

            resetToNeededRecipeAndUom(){
                this.neededCasesVisible = false;
                this.preferProducts = this.originalPreferProducts;
                this.defaultHighestNeededRecipeUom();
            },

            packWise() {
                this.neededCasesVisible = false;
                this.resetToNeededRecipeAndUom();
                const preferProducts = this.preferProducts;

                Object.keys(preferProducts).forEach((index) => {
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        console.log(preferProducts[index][product]);
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        this.packWiseMeasurementOfProduct(preferProduct)
                    });
                });

            //   console.log('not_convertable', this.preferProducts);
            },


            caseWiseMeasurement(){
                this.packWise();
                const preferProducts = this.preferProducts;
                Object.keys(preferProducts).forEach((index) => {
                    // console.log('preferProductspreferProductspreferProducts', preferProducts);
                    Object.keys(preferProducts[index]['offering']['products']).forEach((product) => {
                        const preferProduct = preferProducts[index]['offering']['products'][product];
                        if(preferProduct.distributor_id != null && preferProduct.recipe_amount_uom == 'packs'){
                            
                            const packs = Math.ceil( preferProduct.distributors[preferProduct.distributor_id]['case_weight'] / preferProduct.distributors[preferProduct.distributor_id]['sub_case_weight']);
                            preferProduct.needed_recipe_amount = Math.ceil(preferProduct.needed_recipe_amount/packs);
                            preferProduct.recipe_amount_uom = 'cases';
                        }
                    });
                });
            },

            changeDistributor(index, pIndex, distributorId, pProduct){
                // console.log('changeDistributor', pProduct);
                let confirmResult = false;
                if(confirm('Would you like to assign this distributor as the product default too?')){
                    confirmResult = true;
                    this.$toast.success('Distributor assigned successfully. Please update the case info.');
                    // console.log({ product: pProduct.product_id, distributor: distributorId });
                    axios.post('/add-distributor-to-default-product', { product: pProduct.product_id, distributor: distributorId }).then((response) => {}).catch((error) => console.error(error));
                }
                // console.log('confirmed after');
                if (this.originalPreferProducts[index] && this.originalPreferProducts[index]['offering']['products'][pIndex]) {

                    this.originalPreferProducts[index]['offering']['products'][pIndex].distributor_id = distributorId;
                    var preferProduct = this.preferProducts[index]['offering']['products'][pIndex];
                    preferProduct.setDistributerByDefault = confirmResult;

                    // console.log('on change Distributor preferProducts', preferProduct);

                    const pProductRecipeAmountUom = preferProduct.recipe_amount_uom;
                    if(preferProduct.distributor_id != null && preferProduct.distributor_id != ''){
                        if( pProductRecipeAmountUom == 'packs' || pProductRecipeAmountUom == 'cases'){
                            // console.log('pProductRecipeAmountUom', pProductRecipeAmountUom);
                            const originalProduct = this.originalPreferProducts[index]['offering']['products'][pIndex];
                            const oldUomType = this.$helpers.uomType(originalProduct.default_recipe_amount_uom);
                            const oldUom = originalProduct.default_recipe_amount_uom ;
                            const initNeedeAmount = originalProduct.default_needed_recipe_amount;
                            this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom,  preferProduct);
                            this.packWiseMeasurementOfProduct(preferProduct);

                            if(pProductRecipeAmountUom == 'cases'){
                                // if(preferProduct.not_convertable && preferProduct.not_convertable != true){
                                    const packs = preferProduct.distributors[preferProduct.distributor_id]['pack'];
                                    preferProduct.needed_recipe_amount = Math.ceil(preferProduct.needed_recipe_amount/packs);
                                    preferProduct.recipe_amount_uom = 'cases';
                                // }
                            }
                        }
                    const result = this.calculateCaseQuantityForProduct(pProduct);
                    preferProduct.case_quantity = result;
                    this.setDefaultCaseQuantity(preferProduct);

                    // console.log('on change Distributor preferProducts', result);
                    preferProduct.not_convertable = (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && result <= 0);
                    }
                }
            },

            getDefaultRecipeAmountUomType(preferProduct) {
                let uom = preferProduct.default_recipe_amount_uom;
                if(uom == 'cases'){
                    uom = 'cases';
                }else if(uom == 'packs'){
                    uom = 'packs';
                }
                // if(this.$helpers.uomType(uom));
                return uom;
            },


            calculateCaseQuantityForProduct(preferProduct) {
                // console.log('calculateCaseQuantityForProduct updateProductDistributors ', preferProduct);

                // preferProduct.needed_recipe_amount = preferProduct.default_needed_recipe_amount;
                //         preferProduct.recipe_amount_uom;

                console.log('calculateCaseQuantityForProduct updateProductDistributors ', preferProduct);

                if (!preferProduct.distributor_id || preferProduct.distributor_id === '') {
                    console.log('calculateCaseQuantityForProduct updateProductDistributors r1');
                    return 0;
                }
                // console.log('updateProductDistributors calculateCaseQuantityForProduct 1 = ', preferProduct);

                const distributor = preferProduct.distributors[preferProduct.distributor_id];
                if (!distributor) {
                    console.log('calculateCaseQuantityForProduct updateProductDistributors r2');
                    return 0;
                }
                // console.log('updateProductDistributors calculateCaseQuantityForProduct 2 = ', preferProduct);
                let yields = (preferProduct.yield ?? 100) / 100;
                // alert(yields);

                const sizewithUnit = distributor['size'] ?? '';
                let sizeAmount = distributor['case_weight'] * yields;
                let packs = distributor['case_weight'] / distributor['sub_case_weight'];
                if(!packs){
                    packs = 1;
                }
                let sizeUnit = distributor['case_weight'];
                let newUom = distributor['case_weight_uom'];

                let oldUom = preferProduct.default_recipe_amount_uom;
                let oldUomCustom = preferProduct.default_recipe_amount_custom_uom;
                let productUom = preferProduct.default_recipe_amount_uom;
                let initNeedeAmount = preferProduct.default_needed_recipe_amount;
                let isCustom = false;
                if(['cases', 'packs'].includes(oldUom)){
                    
                } else if(['Weight', 'Volume', 'Unit'].includes(this.$helpers.uomType(oldUom))){
                    if(this.$helpers.uomType(oldUom) == 'Weight'){
                        newUom = distributor['case_weight_uom'];
                        sizeAmount = distributor['case_weight'] * yields;
                        packs = distributor['case_weight'] / distributor['sub_case_weight'];
                        
                    } else if(this.$helpers.uomType(oldUom) == 'Volume'){
                        newUom = distributor['case_volume_uom'];        
                        sizeAmount = distributor['case_volume'];
                        packs = distributor['case_volume'] / distributor['sub_case_volume'];
                    } else if(this.$helpers.uomType(oldUom) == 'Unit'){
                        newUom = 'Each';
                        sizeAmount = distributor['case_qty'];
                        packs = distributor['case_qty'] / distributor['sub_case_qty'];
                    }
                    
                } else if(['Weight', 'Volume', 'Unit'].includes(this.$helpers.uomType(oldUomCustom))){
                    isCustom = true;
                    productUom = oldUomCustom;
                    if(this.$helpers.uomType(oldUomCustom) == 'Weight'){
                        newUom = distributor['case_weight_uom'];
                        sizeAmount = distributor['case_weight']  * yields;
                        packs = distributor['case_weight'] / distributor['sub_case_weight'];
                    } else if(this.$helpers.uomType(oldUomCustom) == 'Volume'){
                        newUom = distributor['case_volume_uom'];
                        sizeAmount = distributor['case_volume'];
                        packs = distributor['case_volume'] / distributor['sub_case_volume'];
                    } else if(this.$helpers.uomType(oldUomCustom) == 'Unit'){
                        newUom = 'Each';
                        sizeAmount = distributor['case_qty'];
                        packs = distributor['case_qty'] / distributor['sub_case_qty'];
                    }
                }

                if(!packs){
                    packs = 1;
                }

                
                    

                if (oldUom === 'cases') {
                    return initNeedeAmount;
                } else if (oldUom === 'packs') {
                    return Math.ceil(initNeedeAmount / packs);
                }                

                let result = this.calculateQuantityWithConversion(preferProduct, newUom, sizeAmount, packs, initNeedeAmount, oldUom);  
                
                console.log("estimateOrder", initNeedeAmount, result);
                if(preferProduct.needed > 0){
                    if(preferProduct.recipe_amount_uom != preferProduct.default_recipe_amount_uom){
                        if(preferProduct.needed_recipe_amount > 0){
                            if(preferProduct.needed_recipe_amount < preferProduct.needed){
                                return 0;
                            } else {
                                console.log("estimateOrder else ", preferProduct.needed_recipe_amount, result, preferProduct.needed, preferProduct.needed_recipe_amount - preferProduct.needed);
                                result = this.calculateCase(preferProduct.needed_recipe_amount, result, preferProduct.needed_recipe_amount - preferProduct.needed);
                            }
                        }
                    } else {
                        result = this.calculateCase(preferProduct.needed_recipe_amount, result, preferProduct.needed_recipe_amount - preferProduct.needed);
                    }
                }

                console.log("estimateOrder in last", initNeedeAmount, result);

                if (result > 0) {
                    return result;
                    return Math.ceil(result / packs);
                } else {
                    return 0;
                }

            },

            calculateCase(recipeAmount, totalCase, inputAmount) {
                 return Math.ceil(inputAmount / (recipeAmount / totalCase));
            },

            packWiseMeasurementOfProduct(preferProduct) {
                console.log('packWiseMeasurementOfProduct in', preferProduct);

                if (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && preferProduct.distributors[preferProduct.distributor_id]) {
                    // console.log('packWiseMeasurementOfProduct in in', preferProduct);

                let distributor = preferProduct.distributors[preferProduct.distributor_id];
                let yields = (preferProduct.yield ?? 100) / 100;


                let sizeAmount = distributor['case_weight'] * yields;
                let packs = distributor['case_weight'] / distributor['sub_case_weight'];
                let sizeUnit = distributor['case_weight'];
                let newUom = distributor['case_weight_uom'];

                let oldUom = preferProduct.default_recipe_amount_uom;
                let oldUomCustom = preferProduct.default_recipe_amount_custom_uom;
                let productUom = preferProduct.default_recipe_amount_uom;
                const initNeedeAmount = (preferProduct.default_needed_recipe_amount - (preferProduct.needed >
                    preferProduct.default_needed_recipe_amount ? 0 : preferProduct.needed));

                let isCustom = false;
                // alert(oldUom);

                if(['cases', 'packs'].includes(oldUom)){
                    
                } else if(['Weight', 'Volume', 'Unit'].includes(this.$helpers.uomType(oldUom))){
                    // alert(this.$helpers.uomType(oldUom));
                    if(this.$helpers.uomType(oldUom) == 'Weight'){
                        newUom = distributor['case_weight_uom'];
                        sizeAmount = distributor['case_weight'] * yields;
                        packs = distributor['case_weight'] / distributor['sub_case_weight'];
                    } else if(this.$helpers.uomType(oldUom) == 'Volume'){
                        // alert(oldUom);
                        newUom = distributor['case_volume_uom'];        
                        sizeAmount = distributor['case_volume'];
                        packs = distributor['case_volume'] / distributor['sub_case_volume'];
                        
                    } else if(this.$helpers.uomType(oldUom) == 'Unit'){
                        newUom = 'Each';
                        sizeAmount = distributor['case_qty'];
                        packs = distributor['case_qty'] / distributor['sub_case_qty'];
                    }
                } else if(['Weight', 'Volume', 'Unit'].includes(this.$helpers.uomType(oldUomCustom))){
                    isCustom = true;
                    productUom = oldUomCustom;
                    if(this.$helpers.uomType(oldUomCustom) == 'Weight'){
                        newUom = distributor['case_weight_uom'];
                        sizeAmount = distributor['case_weight'] * yields;
                        packs = distributor['case_weight'] / distributor['sub_case_weight'];
                    } else if(this.$helpers.uomType(oldUomCustom) == 'Volume'){
                        newUom = distributor['case_volume_uom'];
                        sizeAmount = distributor['case_volume'];
                        packs = distributor['case_volume'] / distributor['sub_case_volume'];
                    } else if(this.$helpers.uomType(oldUomCustom) == 'Unit'){
                        newUom = 'Each';
                        sizeAmount = distributor['case_qty'];
                        packs = distributor['case_qty'] / distributor['sub_case_qty'];
                    }
                }

                    // console.log('result in packWiseMeasurementOfProduct newUomnewUom', newUom);

                    if (newUom != 'Not Found') {

                        const newUomType = this.$helpers.uomType(newUom);
                        const oldUomType = this.$helpers.uomType(preferProduct.recipe_amount_uom);
                        // let oldUom = preferProduct.recipe_amount_uom;
                        // oldUom = productUom;
                        // const initNeedeAmount = preferProduct.needed_recipe_amount;

                        if(!packs){
                        packs = 1;
                    }


                        const result = this.calculateQuantityWithConversion(preferProduct, newUom, sizeAmount, packs, initNeedeAmount, oldUom);

                        if (result > 0) {
                            preferProduct.needed_recipe_amount = Number(result *  packs).toFixed(2);
                            preferProduct.recipe_amount_uom = 'packs';
                            preferProduct.not_convertable = false;
                        } else {
                            preferProduct.not_convertable = true;
                        }
                    } else {
                        // console.log('else part not found', preferProduct);
                        preferProduct.needed_recipe_amount = preferProduct.default_needed_recipe_amount;
                        preferProduct.recipe_amount_uom = preferProduct.default_recipe_amount_uom;
                        preferProduct.not_convertable = true;
                    }
                }
            },

            calculateQuantityWithConversion(preferProduct, newUom, sizeAmount, packs, initNeedeAmount, oldUom) {

                const newUomType = this.$helpers.uomType(newUom);
                const oldUomType = this.$helpers.uomType(oldUom);
                if(initNeedeAmount <=0){
                    initNeedeAmount = preferProduct.needed_recipe_amount > 0 ? preferProduct.needed_recipe_amount : preferProduct.default_needed_recipe_amount;
                }

                preferProduct.needed_recipe_amount;                

                let newRecipeAmount;
                // console.log('newUomType oldUomType', newUomType, oldUomType);
                if(newUomType === 'Unit' && oldUomType === 'Unit'){
                    newRecipeAmount = initNeedeAmount;
                    let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                    return neededPacks;
                }

                if (newUomType === oldUomType && newUomType === 'Weight') {
                    newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, newUom);
                    let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                    console.log('calculateQuantityWithConversion neededPacks',oldUom, newUom);
                    return neededPacks;
                } else if (newUomType === oldUomType && newUomType === 'Volume') {
                    newRecipeAmount = this.$conversions.volume(initNeedeAmount, oldUom, newUom);
                    let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                    return neededPacks;
                } else if (newUomType === 'Weight' && oldUomType === 'Volume') {
                    newRecipeAmount = this.$conversions.volumeToWeight(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
                    console.log("newRecipeAmount", newRecipeAmount);
                    if (newRecipeAmount != null) {
                        let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                        return neededPacks;
                    }
                    return 0;
                } else if (newUomType === 'Volume' && oldUomType === 'Weight') {
                    newRecipeAmount = this.$conversions.weightToVolume(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
                    if (newRecipeAmount != null) {
                        let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                        return neededPacks;
                    }
                    return 0;
                } 
                
                else if (newUomType === 'Unit' && oldUomType === 'Weight') {
                    if (preferProduct.nutrition_facts_weight_uom !== null && preferProduct.nutrition_facts_weight > 0) {
                        newRecipeAmount = this.$conversions.weight( initNeedeAmount, oldUom, preferProduct.nutrition_facts_weight_uom);
                        console.log("UnitWeight 1 = ", newRecipeAmount, initNeedeAmount, oldUom, preferProduct.nutrition_facts_weight_uom);
                        if (newRecipeAmount != null) {
                            newRecipeAmount = newRecipeAmount / preferProduct.nutrition_facts_unit;
                            console.log("UnitWeight 2 = ", newRecipeAmount);
                            let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                            console.log("UnitWeight 3 = ", neededPacks);
                            return neededPacks;                            
                        }
                    }
                }
                else if (newUomType === 'Weight' && oldUomType === 'Unit') {
                    if (preferProduct.nutrition_facts_weight_uom !== null && preferProduct.nutrition_facts_weight > 0) {
                        if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
                            const productNutritionFactsWeight = parseFloat(preferProduct.nutrition_facts_weight);
                            const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
                            const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
                            const initNeedeAmount = ((productNutritionFactsWeight / productNutritionFactsUnit) * productNutritionecipeAmountUom);
                            const oldUom = preferProduct.nutrition_facts_weight_uom;
                            const newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, newUom);
                            let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                            return neededPacks;
                        }

                    } else if (preferProduct.nutrition_facts_volume_uom !== null && preferProduct.nutrition_facts_volume > 0) {

                        if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
                            const productNutritionFactsVolume = parseFloat(preferProduct.nutrition_facts_volume);
                            const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
                            const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
                            const initNeedeAmount = ((productNutritionFactsVolume / productNutritionFactsUnit) * productNutritionecipeAmountUom);

                            const oldUom = preferProduct.nutrition_facts_volume_uom;
                            const newRecipeAmount = this.$conversions.volumeToWeight(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
                            let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                            return neededPacks;
                        }
                    }
                } else if (newUomType === 'Volume' && oldUomType === 'Unit') {
                    if (preferProduct.nutrition_facts_volume_uom !== null && preferProduct.nutrition_facts_volume > 0) {
                        if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
                            const productNutritionFactsVolume = parseFloat(preferProduct.nutrition_facts_volume);
                            const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
                            const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
                            const initNeedeAmount = ((productNutritionFactsVolume / productNutritionFactsUnit) * productNutritionecipeAmountUom);
                            const oldUom = preferProduct.nutrition_facts_volume_uom;
                            // console.log("conversions to ", initNeedeAmount, oldUom, newUom);

                            const newRecipeAmount = this.$conversions.volume(initNeedeAmount, oldUom, newUom);
                            let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                            return neededPacks;
                        }
                    } else if (preferProduct.nutrition_facts_weight_uom !== null && preferProduct.nutrition_facts_weight > 0) {
                        if (preferProduct.nutrition_facts_unit != null && preferProduct.nutrition_facts_unit != '') {
                            const productNutritionFactsWeight = parseFloat(preferProduct.nutrition_facts_weight);
                            const productNutritionecipeAmountUom = preferProduct.needed_recipe_amount;
                            const productNutritionFactsUnit = parseFloat(preferProduct.nutrition_facts_unit);
                            const initNeedeAmount = ((productNutritionFactsWeight / productNutritionFactsUnit) * productNutritionecipeAmountUom);
                            const oldUom = preferProduct.nutrition_facts_weight_uom;
                            // console.log("conversions to ", initNeedeAmount, oldUom, newUom);

                            newRecipeAmount = this.$conversions.weightToVolume(preferProduct, initNeedeAmount, oldUom, newUom, preferProduct.cuoms);
                            let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                            return neededPacks;
                        }
                    }
                } else if (newUomType === 'Custom' && oldUomType === 'Weight' && preferProduct.cuoms) {
                    let cuomsLength = preferProduct.cuoms.length;
                    // console.log('yes founc cuomsLength', cuomsLength);

                    if (cuomsLength >= 1) {
                        for (let i = 0; i < cuomsLength; i++) {
                            if (preferProduct.cuoms[i].description1 == '||' + newUom + '||') {
                                newRecipeAmount = this.$conversions.weight(initNeedeAmount, oldUom, preferProduct.cuoms[i].weight_units);
                                let sc = preferProduct.cuoms[i].weight / preferProduct.cuoms[i].unit_amount;
                                newRecipeAmount = newRecipeAmount / sc;
                                let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                                return neededPacks;
                            }
                        }
                    }
                } else if (newUomType === 'Custom' && oldUomType === 'Volume' && preferProduct.cuoms) {
                    let cuomsLength = preferProduct.cuoms.length;
                    if (cuomsLength >= 1) {
                        for (let i = 0; i < cuomsLength; i++) {
                            // console.log('foundOne', preferProduct.cuoms[i].description1, newUom);
                            if (preferProduct.cuoms[i].description1 == '||' + newUom + '||') {
                                // volumn to weight
                                newRecipeAmount = this.$conversions.volumeToWeight(preferProduct, initNeedeAmount, oldUom, preferProduct.cuoms[i].weight_units, preferProduct.cuoms);
                                // weight to gram
                                let sc = preferProduct.cuoms[i].weight / preferProduct.cuoms[i].unit_amount;
                                newRecipeAmount = newRecipeAmount / sc;
                                let neededPacks = Math.ceil(newRecipeAmount / sizeAmount);
                            }
                        }
                    }
                    return 0;
                } else if (newUomType === 'Custom' && oldUomType === 'Custom' && preferProduct.cuoms) {
                        console.log('this is part of custom to custom', preferProduct);
                        let weight_units = null;
                        for (let i = 0; i < preferProduct.cuoms.length; i++) {
                        // custom to weight
                            if(preferProduct.cuoms[i].description1 == '||'+oldUom+'||')
                            {
                                initNeedeAmount = initNeedeAmount / preferProduct.cuoms[i].unit_amount;
                                weight_units = preferProduct.cuoms[i].weight_units;
                                newRecipeAmount = this.$conversions.weight(initNeedeAmount, preferProduct.cuoms[i].weight_units, preferProduct.cuoms[i].weight_units);

                                let neededPacks = Math.ceil(newRecipeAmount/sizeAmount);
                                console.log('this is part of custom to custom neededPacks', neededPacks);
                                return neededPacks;
                            }
                        }

                        // weight to custom
                        for (let i = 0; i < preferProduct.cuoms.length; i++) {
                            if(preferProduct.cuoms[i].description1 == '||'+newUom+'||')
                            {
                                // let smo = newRecipeAmount / preferProduct.cuoms[i].unit_amount;
                                newRecipeAmount = this.$conversions.weight(initNeedeAmount, weight_units, preferProduct.cuoms[i].weight_units);
                                newRecipeAmount = newRecipeAmount *  preferProduct.cuoms[i].unit_amount;
                                let neededPacks = Math.ceil(newRecipeAmount/sizeAmount);
                                return neededPacks;
                            }
                        }
                        return 0;
                    }
                else if(oldUomType === 'Custom') {
                    // console.log('newUomType oldUomType Custom', preferProduct);
                    for (let i = 0; i < preferProduct.cuoms.length; i++) {
                            if(preferProduct.cuoms[i].description1 == '||'+oldUom+'||')
                            {
                                // console.log('newUomType oldUomType Custom in', newUomType);
                                if(newUomType === 'Weight') {
                                    // custom to weight
                                    initNeedeAmount = initNeedeAmount / preferProduct.cuoms[i].unit_amount;
                                    let weight_units = preferProduct.cuoms[i].weight_units;
                                    newRecipeAmount = this.$conversions.weight(initNeedeAmount, preferProduct.cuoms[i].weight_units, newUom);

                                    let neededPacks = Math.ceil(newRecipeAmount/sizeAmount);
                                    return neededPacks;
                                } else if(newUomType === 'Volume') {
                                    // console.log('newUomType oldUomType Custom in = initNeedeAmount ', initNeedeAmount);
                                    // custom to volume
                                    initNeedeAmount = initNeedeAmount / preferProduct.cuoms[i].unit_amount;
                                    // console.log('newUomType oldUomType Custom in = initNeedeAmount ', initNeedeAmount);
                                    // let weight_units = preferProduct.cuoms[i].weight_units;
                                    newRecipeAmount = this.$conversions.volume( initNeedeAmount, preferProduct.cuoms[i].unit_type, newUom);

                                    // console.log('newUomType oldUomType Custom in = newRecipeAmount ', newRecipeAmount, initNeedeAmount, preferProduct.cuoms[i].unit_type, newUom, sizeAmount);

                                    let neededPacks = Math.ceil(newRecipeAmount/sizeAmount);
                                    // console.log('newUomType oldUomType Custom in = neededPacks ', neededPacks);
                                    return neededPacks;
                                } 
                                else if(newUomType === 'Unit') {
                                    // custom to unit
                                    newRecipeAmount = initNeedeAmount / preferProduct.cuoms[i].unit_amount;

                                    let neededPacks = Math.ceil(newRecipeAmount/sizeAmount);
                                    return neededPacks;
                                }
                                // initNeedeAmount = initNeedeAmount / preferProduct.cuoms[i].unit_amount;
                                // // weight_units = preferProduct.cuoms[i].weight_units;
                                // newRecipeAmount = this.$conversions.weight(initNeedeAmount, preferProduct.cuoms[i].weight_units, preferProduct.cuoms[i].weight_units);

                                // let neededPacks = Math.ceil(newRecipeAmount/sizeAmount);
                                // return neededPacks;
                            }
                    
                        
                    }
                }

                else {
                    return 0;
                }
            },

            getFullFormOfUnit(value) {
                switch (value.toUpperCase()) {
                    case "OZ":
                    case "OUNCE":
                        return "Ounce";
                    case "GRAM":
                    case "GRM":
                    case "G":
                    case "GM":
                        return "Gram";
                    case "LB":
                    case "POUND":
                        return "LB";
                    case "GAL":
                    case "GALLON":
                        return "Gallon";
                    case "ML":
                    case "Milliliter":
                        return "Milliliter";
                    case "DOZEN":
                    case "DZ":
                        return "Dozen";
                    case "EA":
                    case "EACH":
                        return "Each";
                    case "IN":
                    case "INCH":
                        return "Inch";
                    case "PINT":
                    case "PT":
                        return "Pint";
                    case "BAGS":
                        return "Bags";
                    case "CT":
                        return "CT";
                    case "CASE":
                        return "Case";
                    case "QUART":
                        return "Quart";
                    case "CUP":
                        return "Cup";
                    case "FLUID OUNCE":
                        return "Fluid Ounce";
                    case "TABLESPOON":
                        return "Tablespoon";
                    case "TEASPOON":
                        return "Teaspoon";
                    default:
                        return "Not Found";
                }
            },

            formattedValue(value) {
                if(value === null || value === undefined || value === ''){
                    return value;                    
                }

                if (Number.isInteger(value)) {
                    return value;
                } else {
                    // console.log(value, typeof value, value);
                    return Number(value).toFixed(2);
                }
            },

            addDistributorError() {
                this.distributorNotSelectCount = 0;
                Object.values(this.preferProducts).forEach((productGroup) => {
                    Object.values(productGroup.offering.products).forEach((product) => {
                        if(!product.ignored){
                            product.distributor_error = !product.distributor_id;
                            this.distributorNotSelectCount += product.distributor_error ? 1 : 0;
                        } else {
                            product.distributor_error = false;
                        }
                    });
                });
                // console.log(this.distributorNotSelectCount);
                // console.log(this.preferProducts);
            },

            accordianShow(offering) {
                // console.log('accordian show', offering);
                this.isOpenOffering.push(offering);
                // this.isOpenOffering = ! this.isOpenOffering;
                // console.log('accordian array', this.isOpenOffering);

            },
            accordianHide(offering) {
                // console.log('accordian hide', offering);
                const index = this.isOpenOffering.indexOf(offering);
                if (index > -1) { // only splice array when item is found
                    this.isOpenOffering.splice(index, 1); // 2nd parameter means remove one item only
                }
                // console.log('accordian array', this.isOpenOffering);
            },



            changeOrderValue(index, pIndex, pProdcut) {
                pProdcut.needed = Math.max(0, pProdcut.needed);
                const preferProduct = this.preferProducts[index]['offering']['products'][pIndex];

                if (pProdcut.needed > pProdcut.needed_recipe_amount || pProdcut.needed < 0) {
                    preferProduct.ignoredCheckboxShow = true;
                }else{
                    preferProduct.ignoredCheckboxShow = false;
                }
                preferProduct.ignored = false;
                preferProduct.case_quantity  = this.calculateCaseQuantityForProduct(pProdcut);
                this.setDefaultCaseQuantity(preferProduct);
            },


            NewVersionCreateFoodOrder() {
                this.current_version += 1;
                this.CreateFoodOrder();
            },

            CreateFoodOrder() {

                this.hideShowLoader('show');
                // this.addDistributorError();
                // if (this.distributorNotSelectCount === 0) {
                    // console.log('data', this.preferProducts);
                    axios
                        .post("/food-order/store/step-3?current_version="+this.current_version, {
                            order_id: this.order_id,
                            data: this.preferProducts,
                            food_create_type: this.food_create_type,
                            food_create_id: this.food_create_id,
                        })
                        .then((response) => {
                            console.log('food-order.store.step-4', response);
                            if (response.data.status == 'success') {
                                window.location.href = `create4?order_id=${response.data.data.id}`;
                            } else {
                                this.hideShowLoader('hide');
                            }
                            console.log(response.data.status);
                        })
                        .catch((error) => console.error(error));
                // }
            },

            createNewDistributor(data) {
                console.log(data);
                this.showDistributorPopup = false;
                this.all_distributors.push(data);                
            },

            addDistributorItem(distributor_product) {

                const activeProduct = this.activeProductId;
                const clickedOfferingKey = this.currentProductIndex;
                const clickedProductKey = this.currentProductKey;

                Object.keys(this.preferProducts).forEach(offeringKey => {
                    // console.log('offeringKey', offeringKey);
                     const products = this.preferProducts[offeringKey].offering.products;

                     Object.keys(products).forEach(productKey => {
                        const product = products[productKey];
                         if (product.product_id === activeProduct) {

                            if (!product.distributors || Array.isArray(product.distributors)) {
                                product.distributors = {};
                            }

                            const newDistributor = {
                                name: `${distributor_product.distributor.name} (${distributor_product.case_cost})`,
                                id: distributor_product.distributor_id,
                                pack: distributor_product.pack,
                                size: distributor_product.size
                            };
                            product.distributors[distributor_product.distributor_id] = newDistributor;
                            // product.distributor_id = distributor_product.distributor_id;
                            if (offeringKey === clickedOfferingKey && productKey === clickedProductKey) {
                                product.distributor_id = distributor_product.distributor_id;
                            }
                         }
                     });
                });


                    axios
                    .post(route('add-distributor-to-product',{product: activeProduct}), {
                        distributor_products: distributor_product
                    })
                    .then((response) => {
                        if (response.data.status == 'success') {
                            window.location.href = `create4?order_id=${response.data.data.id}`;
                        }
                    })
                    .catch((error) => console.error(error));
            },

            openDistributorPopup(index, product) {
                this.showDistributorPopup = true;
                this.currentProductIndex = index;
                this.currentProductKey = product;
                const preferProduct = this.preferProducts[index].offering.products[product];
                this.activeProductId = preferProduct.product_id;
                this.filteredDistributors = this.getFilteredDistributors(preferProduct);
            },

            getFilteredDistributors(preferProduct) {
                if (!preferProduct || !preferProduct.distributors) {
                    return this.all_distributors;
                }
                const existingDistributorIds = Object.keys(preferProduct.distributors).map(id =>id);

                return this.all_distributors.filter(distributor =>
                    !existingDistributorIds.includes(distributor.id)
                );
            },
            selectedCustomUnitOfMeasurement(pro, recipe_amount_uom) {
                return pro.cuoms?.find((cuom) => cuom.description1 === recipe_amount_uom);
            },

            changeNeededAmount(pro) {
                pro.default_needed_recipe_amount = Number(pro.needed_recipe_amount).toFixed(2);
                pro.default_recipe_amount_uom = pro.recipe_amount_uom;
            },
            changeUom(pro) {
                this.calculateDistributorPrice(pro);


                // console.log('changeUom', pro);
                let newUom = pro.recipe_amount_uom;
                let oldUom = pro.default_recipe_amount_uom;

                const newUomType = this.$helpers.uomType(newUom);
                const oldUomType = this.$helpers.uomType(oldUom);

                if(!oldUom){
                    pro.default_recipe_amount_uom = newUom;
                    return;
                }
                if(newUom == oldUom){
                    if(oldUomType == 'Unit'){
                        pro.needed_recipe_amount = Math.ceil(pro.default_needed_recipe_amount);
                    } else {
                        pro.needed_recipe_amount = Number(pro.default_needed_recipe_amount).toFixed(2);
                    }
                    return;
                }

                let recipe_amount_custom_uom = null;
                let newRecipeAmount = null;
                let recipe_amount = pro.default_needed_recipe_amount ?? pro.needed_recipe_amount;
                let isCustomUnit = true;

                
                if (newUomType === 'Custom' && newUom) {
                    // console.error('isCustomUnit', this.isCustomUnit, newUomType, newUom);
                    isCustomUnit = true;
                    const cuom = this.selectedCustomUnitOfMeasurement(pro, newUom);
                    if (cuom) {
                        recipe_amount_custom_uom = cuom.unit_type;
                    }
                    return;
                } else {
                    isCustomUnit = false;
                }

                if (recipe_amount === null || recipe_amount === Infinity) {
                    recipe_amount = '';
                    return;
                }

                let initAmount = newRecipeAmount= recipe_amount;

                if (newUomType === oldUomType && newUomType === 'Weight') {
                    newRecipeAmount = this.$conversions.weight(initAmount, oldUom, newUom);
                }

                if (newUomType === oldUomType && newUomType === 'Volume') {
                    newRecipeAmount = this.$conversions.volume(initAmount, oldUom, newUom);
                }

                if (newUomType === 'Weight' && oldUomType === 'Volume') {
                    newRecipeAmount = this.$conversions.volumeToWeight(pro, recipe_amount, oldUom, newUom)
                }

                if (newUomType === 'Volume' && oldUomType === 'Weight') {
                    newRecipeAmount = this.$conversions.weightToVolume(pro, recipe_amount, oldUom, newUom)
                }

                if (newUomType === oldUomType && newUomType === 'Unit') {
                    newRecipeAmount = Math.ceil(initAmount);
                }

                /**
                 * Custom Unit
                 */
                console.log('changeUom ended', newRecipeAmount, newUomType , oldUomType);
                pro.needed_recipe_amount = Number(newRecipeAmount).toFixed(2); 
            },

            changeCustomUom(pro) {
            // console.log('changeCustomUom called', pro);
            let newVal = pro.recipe_amount_custom_uom;
            let oldVal = pro.default_recipe_amount_custom_uom;
            let newServingAmount = null;
            let initAmount = pro.default_needed_recipe_amount;
            let serving_amount = pro.default_needed_recipe_amount;
            if(newVal == oldVal){
                pro.needed_recipe_amount = Number(pro.default_needed_recipe_amount).toFixed(2);
                return;
            }

            const newUomType = this.$helpers.uomType(newVal);
            const oldUomType = this.$helpers.uomType(oldVal);
            const cuom = pro.default_cuom;


            

            if (newUomType === 'Weight' && (!oldVal || oldUomType === 'Weight')) {
                newServingAmount = this.$conversions.weight(serving_amount, oldVal, newVal);
            }
            //
            if (oldUomType === 'Weight' && newUomType === 'Volume') {
                newServingAmount = (this.$conversions.weightToVolume(pro, initAmount, oldVal, newVal, [cuom])
                );
            }
            if (oldUomType === 'Volume' && newUomType === 'Weight') {
                newServingAmount = (this.$conversions.volumeToWeight(pro, initAmount, oldVal, newVal, [cuom])
                );
            }
            if (oldUomType === 'Volume' && newUomType === oldUomType) {
                newServingAmount = this.$conversions.volume(serving_amount, oldVal, newVal);
            }

            if (newUomType === 'Unit' && oldUomType === 'Unit') {
                newServingAmount = initAmount;
            }

            if (newUomType === 'Unit' && oldUomType === 'Weight') {

                if (oldVal != cuom.weight_units) {
                    initAmount = this.$conversions.weight(initAmount, oldVal, cuom.weight_units);
                }
                newServingAmount = initAmount / (cuom.weight / cuom.unit_amount);
            }

            if (oldUomType === 'Unit' && newUomType === 'Weight') {
                newServingAmount = initAmount * (cuom.weight / cuom.unit_amount);
                if (newVal != cuom.weight_units) {
                    newServingAmount = this.$conversions.weight(newServingAmount, cuom.weight_units, newVal);
                }
            }

            // console.log('changeCustomUom newServingAmount', newServingAmount, oldUomType ,oldVal,newUomType, newVal);


            pro.needed_recipe_amount = Number(newServingAmount).toFixed(2);

            },

            updateProductDistributors(index, pIndex, pProduct, distributor) {
                console.log('updateProductDistributors ', index, pIndex, pProduct, distributor);

                if (this.originalPreferProducts[index] && this.originalPreferProducts[index]['offering']['products'][pIndex]) {
                    console.log('updateProductDistributors in', index, pIndex, pProduct, distributor);

                    this.originalPreferProducts[index]['offering']['products'][pIndex].distributor_id = distributor.id;
                    var preferProduct = this.preferProducts[index]['offering']['products'][pIndex];
                    console.log('on change Distributor preferProducts', preferProduct);
                    if (!preferProduct.distributors || Array.isArray(preferProduct.distributors)) {
                        preferProduct.distributors = {};
                    }
                    preferProduct.distributors[distributor.id] = distributor;
                    preferProduct.distributor_id = distributor.id;

                    const pProductRecipeAmountUom = preferProduct.recipe_amount_uom;
                    if(preferProduct.distributor_id != null && preferProduct.distributor_id != ''){
                        console.log('updateProductDistributors in2 ', index, pIndex, pProduct, distributor);
                        if( pProductRecipeAmountUom == 'packs' || pProductRecipeAmountUom == 'cases'){
                            // console.log('pProductRecipeAmountUom', pProductRecipeAmountUom);
                            console.log('updateProductDistributors in3 ', index, pIndex, pProduct, distributor);
                            const originalProduct = this.originalPreferProducts[index]['offering']['products'][pIndex];
                            const oldUomType = this.$helpers.uomType(originalProduct.default_recipe_amount_uom);
                            const oldUom = originalProduct.default_recipe_amount_uom ;
                            const initNeedeAmount = originalProduct.default_needed_recipe_amount;
                            if(oldUomType == 'unit')
                            {
                               initNeedeAmount = Math.ceil(initNeedeAmount);
                            }

                            this.highestNeededRecipeAndUomOfProduct(initNeedeAmount, oldUomType, oldUom,  preferProduct);
                            this.packWiseMeasurementOfProduct(preferProduct);

                            if(pProductRecipeAmountUom == 'cases'){
                                // if(preferProduct.not_convertable && preferProduct.not_convertable != true){
                                    // const packs = preferProduct.distributors[preferProduct.distributor_id]['pack'];
                                    const packs = preferProduct.distributors[preferProduct.distributor_id]['case_weight'] / preferProduct.distributors[preferProduct.distributor_id]['sub_case_weight'];

                                    console.log('updateProductDistributors in4 in ', packs, preferProduct.needed_recipe_amount);
                                    preferProduct.needed_recipe_amount = Math.ceil(preferProduct.needed_recipe_amount/packs);
                                    preferProduct.recipe_amount_uom = 'cases';
                                // }
                            }
                        }
                    const result = this.calculateCaseQuantityForProduct(preferProduct);
                    preferProduct.case_quantity = result;
                    this.setDefaultCaseQuantity(preferProduct);
                    // console.log('updateProductDistributors in4 ', result);
                    // console.log('updateProductDistributors on change Distributor preferProducts', result);
                    preferProduct.not_convertable = (preferProduct.distributor_id != null && preferProduct.distributor_id != '' && result <= 0);
                    }
                }
            }
        }

    };
    </script>


    <style>
    .title::after,
    .title::before {
        content: '';
        position: absolute;
        right: 1.25em;
        top: 1.25em;
        width: 2px;
        height: 0.75em;
        background-color: #7A7572;
        transition: all 0.2s;
    }

    .content p {
        padding: 20px;
    }

    .min-height-third {
        min-height: 400px;
    }

    .span-text {
        font-size: 14px;
        color: #727272;
        padding-bottom: 5px;
    }

    .progress-bar>div {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        height: 23px;
        line-height: 23px;
    }

    .progress-text {
        font-size: 19px;
        color: #3f3f3f;
    }

    .progress-bar {
        background-color: #fff;
        border: 1px solid #cacaca;
        border-radius: 5px;
        height: 25px;
    }

    .bg-green-500 {
        background-color: #22af4b;
    }

    .sm\:text-sm {
        font-size: 0.850rem;
        line-height: 1.25rem;
    }

    .order-detail {
        color: #4a4a4a;
        font-size: 14px;
    }

    .w-52-rec {
        width: 13.2rem;
    }

    .cancel-button-color {
        background-color: #8b8b8b;
    }

    .input-background {
        background-color: #f8f8f8;
    }

    .text-base-heading {
        font-size: 14px;
    }

    .button-bg-color-wed-menu2-gray {
        border: none !important;
        min-height: 35px;
        min-width: 35px;
    }

    .menu1-background-color {
        background-color: #FAA43D;
    }

    .button-bg-color-wed-menu2 {
        background-color: #38558e;
        border: none !important;
        min-height: 35px;
        min-width: 35px;
    }

    .menu1-icon-color {
        color: #38558e;
    }

    .id-color-menu-edit {
        color: #F7A53A;
    }

    .bg-button-color {
        background-color: #cb0000;
    }

    .min-w-min-button {
        min-height: 26px;
        min-width: 53px;

    }

    .w-150 {
        width: 150px;
    }

    .max-w-0-menu1 {
        max-width: 4rem;
    }

    .bg-button-color-green {
        background-color: #22af4b;
    }

    .bg-button-color-gray {
        background-color: #636363;
    }

    .bg-hard-grey {
        background-color: #f4f4f4;
    }

    .font-size-edit {
        font-size: 10.5px;
    }

    .w-96-edit-recipes {
        width: 35rem;
    }

    .select-menu-height-edit2 {
        height: 2.8rem;
    }

    @media screen and (min-width: 1500px) {
        .id_arrow .fa-sort-desc:before {
            content: "\f0dd";
            position: absolute;
            top: 16px;
            left: 43px;
            padding-left: 7px;
            color: #219FD5;
        }

        .id_arrow .fa-sort-asc:before {
            content: "\f0de";
            color: #219FD5;
            padding-left: 7px;
            position: absolute;
            top: 16px;
            left: 43px;
        }
    }

    @media screen and (max-width: 1499px) {
        .id_arrow .fa-sort-asc:before {
            content: "\f0de";
            color: #219FD5;
            padding-left: 7px;
            position: absolute;
            top: 28px;
            left: 43px;
        }

        .id_arrow .fa-sort-desc:before {
            content: "\f0dd";
            position: absolute;
            top: 28px;
            left: 43px;
            padding-left: 7px;
            color: #219FD5;
        }
    }

    @media screen and (max-width: 1279px) {
        .searching-background-color {
            margin-left: 1.25rem;
            margin-right: 1.25rem;
        }

        .my_table {
            margin-left: 1.25rem;
            margin-right: 1.25rem;
        }

        .bottom_button {
            padding-right: 1.25rem;
            padding-left: 1.25rem;
        }
    }

    @media screen and (max-width: 570px) {

        .right-button,
        .order-detail {
            margin-top: 0.625rem;
        }
    }

    .validation_error_msg {
        font-weight: 400;
        margin: 6px 0 0 !important;
        color: red;
    }


    .max-height{
        max-height: 600px;
    }

    .trim_text {
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
    }

    .tooltip {
        display:inline-block;
        position:relative;
        text-align:left;
    }
    .tooltip .top {
        width: 250px;
        top:50%;
        left:100%;
        margin-left:20px;
        transform:translate(0, -50%);
        padding: 5px 10px;
        color: #444444;
        background-color: #EEEEEE;
        font-weight: normal;
        font-size: 14px;
        border-radius: 5px;
        position: absolute;
        z-index: 99999999;
        box-sizing: border-box;
        box-shadow: 0 1px 8px rgba(0,0,0,0.5);
        display: none;
        white-space: normal;
    }
    .tooltip:hover .top {
        display:block;
    }
    .tooltip .top i {
        position:absolute;
        top:50%;
        right:100%;
        margin-top:-12px;
        width:12px;
        height:24px;
        overflow:hidden;
    }
    .tooltip .top i::after {
        content:'';
        position:absolute;
        width:12px;
        height:12px;
        left:0;
        top:50%;
        transform:translate(50%,-50%) rotate(-45deg);
        background-color:#EEEEEE;
        box-shadow:0 1px 8px rgba(0,0,0,0.5);
    }

    /* .mb-6.bg-white.rounded-lg.overflow-hidden.shadow-xl.transform.transition-all.sm\:w-full.sm\:mx-auto.sm\:max-w-2xl {
        max-width: 90%;
    } */

    </style>
